// The optional City of Walla Walla utility account number on the owner contact
// intake (docs/city-utility-agreement-plan.md §1.3/§4). Shown only when the server
// says the property is inside the City limits (view.showCityUtilityAccountNo), and
// never required — owners often don't have the number handy, and the City form
// carries an optional blank for it when we don't.

import type { OwnerContactAnswers } from '@/lib/ownerContactClient';

export const CITY_UTILITY_ACCOUNT_NO_LABEL =
  'City of Walla Walla utility account number (optional)';
export const CITY_UTILITY_ACCOUNT_NO_HELP =
  "It's on your City utility bill. Leave it blank if you don't have it handy.";

/** The API's limit (routes/ownerContactIntake answersSchema). */
export const CITY_UTILITY_ACCOUNT_NO_MAX = 40;

/**
 * `answers` with the account number set from what the owner typed, capped at the
 * API's 40 characters so a save never 400s. A cleared field is sent as '' (not
 * dropped): the server MERGES posted answers over the saved ones, so an omitted key
 * would keep an old number the owner just deleted. The chain reads '' as "not
 * given". PURE.
 */
export function withCityUtilityAccountNo(
  answers: OwnerContactAnswers,
  typed: string,
): OwnerContactAnswers {
  const value = typed.slice(0, CITY_UTILITY_ACCOUNT_NO_MAX);
  return { ...answers, cityUtilityAccountNo: value.trim() === '' ? '' : value };
}
